import { useEffect, useState } from "react";

function readMinWidthMatch(minWidth: number): boolean {
  if (typeof window === "undefined") return false;
  if (typeof window.matchMedia === "function") {
    return window.matchMedia(`(min-width: ${minWidth}px)`).matches;
  }
  return window.innerWidth >= minWidth;
}

export function useMinWidth(minWidth: number): boolean {
  const [matches, setMatches] = useState(() => readMinWidthMatch(minWidth));

  useEffect(() => {
    if (typeof window === "undefined") return;

    if (typeof window.matchMedia === "function") {
      const mediaQuery = window.matchMedia(`(min-width: ${minWidth}px)`);
      const handleChange = (event: MediaQueryListEvent) => setMatches(event.matches);
      setMatches(mediaQuery.matches);
      mediaQuery.addEventListener("change", handleChange);
      return () => mediaQuery.removeEventListener("change", handleChange);
    }

    const handleResize = () => setMatches(window.innerWidth >= minWidth);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [minWidth]);

  return matches;
}
